module.exports = __webpack_public_path__ + "static/media/95ga07c.4b294c32.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ressources/95gal/95ga07c.jpg
// module id = 322
// module chunks = 0